



import Footer from "../footer";
import Header from "../header";
import HomeAdvancedCard from "../homeCourseCards/HomeAdvancedCard";
import HomebasicCard from "../homeCourseCards/homeBasicCards";
import HomeIntermideateCard from "../homeCourseCards/homeIinterMideateCard";
import HomeTechnicalCard from "../homeCourseCards/homeTechnicalCard";
function AllCourse(){
     return(<>
             <Header/>
                <h2 className="text-center">Have Look On Our fundamentals Courses</h2>
                <HomebasicCard/>
                <h2 className="text-center">Have Look On Our Advanced Courses</h2>
                <HomeAdvancedCard/>
                <h2 className="text-center">Have Look On Our Intermideate Courses</h2>
                <HomeIntermideateCard/>
                <HomeTechnicalCard/>

             <Footer/>
     </>)
}
export default AllCourse;
